import React from 'react';
import { ModalHeader } from 'reactstrap';
import { useSelector, shallowEqual } from 'react-redux';
import daylightWireframe from '../../../../Images/daylight_wireframe.png';
import './CodeMapperHeader.css';
import RefreshMappingsButton from './RefreshMappingsButton';
import PartnerSelector from './PartnerSelector';
import hasPermission from '../../../../Shared/hasPermission';

const CodeMapperHeader = ({ practiceName }) => {
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );

    const canSeeAdmin = hasPermission(['ViewAllPractices'], permissions);

    return (
        <ModalHeader className="text-center">
            <div>
                <img
                    src={daylightWireframe}
                    alt="Wireframe Daylight Logo"
                    height="32px"
                />
                <span className="text-16 ml-3">
                    Daylight Code Mappings - {practiceName}
                </span>
            </div>
            <div className="header-actions">
                {canSeeAdmin && <PartnerSelector />}
                <RefreshMappingsButton />
            </div>
        </ModalHeader>
    );
};

export default CodeMapperHeader;
